export const data = [
    { type: 'action', children: [{ text: '1' }], id: '1' },
    { type: 'scene', children: [{ text: '2' }], id: '2' },
    { type: 'character', children: [{ text: '3' }], id: '3' },
    { type: 'dialogue', children: [{ text: '4' }], id: '4' },
    { type: 'parans', children: [{ text: '5' }], id: '5' },
    { type: 'shot', children: [{ text: '6' }], id: '6' },
    { type: 'transition', children: [{ text: '7' }], id: '7' },
    { type: 'action', children: [{ text: '8' }], id: '8' },
    { type: 'scene', children: [{ text: '9' }], id: '9' },
    { type: 'character', children: [{ text: '10' }], id: '10' },
    { type: 'dialogue', children: [{ text: '11' }], id: '11' },
    { type: 'parans', children: [{ text: '12' }], id: '12' },
    { type: 'shot', children: [{ text: '13' }], id: '13' },
    { type: 'transition', children: [{ text: '14' }], id: '14' },
    { type: 'action', children: [{ text: '15' }], id: '15' },
    { type: 'scene', children: [{ text: '16' }], id: '16' },
    { type: 'character', children: [{ text: '17' }], id: '17' },
    { type: 'dialogue', children: [{ text: '18' }], id: '18' },
    { type: 'parans', children: [{ text: '19' }], id: '19' },
    { type: 'shot', children: [{ text: '20' }], id: '20' },
    { type: 'transition', children: [{ text: '21' }], id: '21' },
    { type: 'action', children: [{ text: '22' }], id: '22' },
    { type: 'scene', children: [{ text: '23' }], id: '23' },
    { type: 'character', children: [{ text: '24' }], id: '24' },
    { type: 'dialogue', children: [{ text: '25' }], id: '25' },
    { type: 'parans', children: [{ text: '26' }], id: '26' },
    { type: 'shot', children: [{ text: '27' }], id: '27' },
    { type: 'transition', children: [{ text: '28' }], id: '28' },
    { type: 'action', children: [{ text: '29' }], id: '29' },
    { type: 'scene', children: [{ text: '30' }], id: '30' },
    { type: 'character', children: [{ text: '31' }], id: '31' },
    { type: 'dialogue', children: [{ text: '32' }], id: '32' },
    { type: 'parans', children: [{ text: '33' }], id: '33' },
    { type: 'shot', children: [{ text: '34' }], id: '34' },
    { type: 'transition', children: [{ text: '35' }], id: '35' },
    { type: 'action', children: [{ text: '36' }], id: '36' },
    { type: 'scene', children: [{ text: '37' }], id: '37' },
    { type: 'character', children: [{ text: '38' }], id: '38' },
    { type: 'dialogue', children: [{ text: '39' }], id: '39' },
    { type: 'parans', children: [{ text: '40' }], id: '40' },
    { type: 'shot', children: [{ text: '41' }], id: '41' },
    { type: 'transition', children: [{ text: '42' }], id: '42' },
    { type: 'action', children: [{ text: '43' }], id: '43' },
    { type: 'scene', children: [{ text: '44' }], id: '44' },
    { type: 'character', children: [{ text: '45' }], id: '45' },
    { type: 'dialogue', children: [{ text: '46' }], id: '46' },
    { type: 'parans', children: [{ text: '47' }], id: '47' },
    { type: 'shot', children: [{ text: '48' }], id: '48' },
    { type: 'transition', children: [{ text: '49' }], id: '49' },
    { type: 'action', children: [{ text: '50' }], id: '50' },
    { type: 'scene', children: [{ text: '51' }], id: '51' },
    { type: 'character', children: [{ text: '52' }], id: '52' },
    { type: 'dialogue', children: [{ text: '53' }], id: '53' },
    { type: 'parans', children: [{ text: '54' }], id: '54' },
    { type: 'shot', children: [{ text: '55' }], id: '55' },
    { type: 'transition', children: [{ text: '56' }], id: '56' },
    { type: 'action', children: [{ text: '57' }], id: '57' },
    { type: 'scene', children: [{ text: '58' }], id: '58' },
    { type: 'character', children: [{ text: '59' }], id: '59' },
    { type: 'dialogue', children: [{ text: '60' }], id: '60' },
    { type: 'parans', children: [{ text: '61' }], id: '61' },
    { type: 'shot', children: [{ text: '62' }], id: '62' },
    { type: 'transition', children: [{ text: '63' }], id: '63' },
    { type: 'action', children: [{ text: '64' }], id: '64' },
    { type: 'scene', children: [{ text: '65' }], id: '65' },
    { type: 'character', children: [{ text: '66' }], id: '66' },
    { type: 'dialogue', children: [{ text: '67' }], id: '67' },
    { type: 'parans', children: [{ text: '68' }], id: '68' },
    { type: 'shot', children: [{ text: '69' }], id: '69' },
    { type: 'transition', children: [{ text: '70' }], id: '70' },
    { type: 'action', children: [{ text: '71' }], id: '71' },
    { type: 'scene', children: [{ text: '72' }], id: '72' },
    { type: 'character', children: [{ text: '73' }], id: '73' },
    { type: 'dialogue', children: [{ text: '74' }], id: '74' },
    { type: 'parans', children: [{ text: '75' }], id: '75' },
    { type: 'shot', children: [{ text: '76' }], id: '76' },
    { type: 'transition', children: [{ text: '77' }], id: '77' },
    { type: 'action', children: [{ text: '78' }], id: '78' },
    { type: 'scene', children: [{ text: '79' }], id: '79' },
    { type: 'character', children: [{ text: '80' }], id: '80' },
    { type: 'dialogue', children: [{ text: '81' }], id: '81' },
    { type: 'parans', children: [{ text: '82' }], id: '82' },
    { type: 'shot', children: [{ text: '83' }], id: '83' },
    { type: 'transition', children: [{ text: '84' }], id: '84' },
    { type: 'action', children: [{ text: '85' }], id: '85' },
    { type: 'scene', children: [{ text: '86' }], id: '86' },
    { type: 'character', children: [{ text: '87' }], id: '87' },
    { type: 'dialogue', children: [{ text: '88' }], id: '88' },
    { type: 'parans', children: [{ text: '89' }], id: '89' },
    { type: 'shot', children: [{ text: '90' }], id: '90' },
    { type: 'transition', children: [{ text: '91' }], id: '91' },
    { type: 'action', children: [{ text: '92' }], id: '92' },
    { type: 'scene', children: [{ text: '93' }], id: '93' },
    { type: 'character', children: [{ text: '94' }], id: '94' },
    { type: 'dialogue', children: [{ text: '95' }], id: '95' },
    { type: 'parans', children: [{ text: '96' }], id: '96' },
    { type: 'shot', children: [{ text: '97' }], id: '97' },
    { type: 'transition', children: [{ text: '98' }], id: '98' },
    { type: 'action', children: [{ text: '99' }], id: '99' },
    { type: 'scene', children: [{ text: '100' }], id: '100' },
]

export const data1 = [
    {
        type: 'action',
        children: [
            {
                text: 'DAYLIGHT. Moving over the towers of downtown Gotham... Closing in on an office building... On a large window... Which SHATTERS to reveal-',
            },
        ],
        id: '2',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. OFFICE, HIGH RISE -- DAY',
            },
        ],
        id: '3',
    },
    {
        type: 'action',
        children: [
            {
                text: 'A man in a CLOWN MASK holding a SMOKING SILENCED PISTOL ejects a shell casing. This is DOPEY.',
            },
        ],
        id: '4',
    },
    {
        type: 'action',
        children: [
            {
                text: 'He turns to a second man, HAPPY, also in clown mask, who steps forward with a CABLE LAUNCHER, aims at a lower roof across the street and FIRES a cable across.',
            },
        ],
        id: '5',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. HIGH-RISE -- DAY',
            },
        ],
        id: '6',
    },
    {
        type: 'action',
        children: [
            {
                text: '...into space. The men SLIDE across the DIZZYING DROP... landing on the lower roof across the street.',
            },
        ],
        id: '7',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. DOWNTOWN GOTHAM -- DAY',
            },
        ],
        id: '8',
    },
    {
        type: 'action',
        children: [
            {
                text: 'A MAN on the corner, back to us, holding a CLOWN MASK. An SUV pulls up. The man gets in, puts on his mask. Inside the car- two other men wearing CLOWN MASKS.',
            },
        ],
        id: '9',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GRUMPY',
            },
        ],
        id: '10',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "Three of a kind. Let's do this.",
            },
        ],
        id: '11',
    },
    {
        type: 'character',
        children: [
            {
                text: 'CHUCKLES',
            },
        ],
        id: '12',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "That's it? Three guys?",
            },
        ],
        id: '13',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GRUMPY',
            },
        ],
        id: '14',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "There's two on the roof. Every guy is an extra share. Five shares is plenty.",
            },
        ],
        id: '15',
    },
    {
        type: 'character',
        children: [
            {
                text: 'CHUCKLES',
            },
        ],
        id: '16',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "Six shares. Don't forget the guy who planned the job.",
            },
        ],
        id: '17',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. ROOFTOP, BANK -- CONTINUOUS',
            },
        ],
        id: '18',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Dopey PRIES open an access panel-',
            },
        ],
        id: '19',
    },
    {
        type: 'character',
        children: [
            {
                text: 'HAPPY',
            },
        ],
        id: '20',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'Why do they call him the Joker?',
            },
        ],
        id: '21',
    },
    {
        type: 'character',
        children: [
            {
                text: 'DOPEY',
            },
        ],
        id: '22',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'I heard he wears make-up.',
            },
        ],
        id: '23',
    },
    {
        type: 'character',
        children: [
            {
                text: 'HAPPY',
            },
        ],
        id: '24',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'Make-up?',
            },
        ],
        id: '25',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. BANK -- CONTINUOUS',
            },
        ],
        id: '26',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Grumpy, Chuckles and Bozo get out of the car and march into the bank CARRYING ASSAULT RIFLES-',
            },
        ],
        id: '27',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. BANK -- DAY',
            },
        ],
        id: '28',
    },
    {
        type: 'action',
        children: [
            {
                text: 'The Security Guard looks up- Grumpy FIRES into the ceiling. Customers SCREAM. Chuckles CRACKS the Security Guard.',
            },
        ],
        id: '29',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. ROOFTOP -- DAY',
            },
        ],
        id: '30',
    },
    {
        type: 'character',
        children: [
            {
                text: 'DOPEY',
            },
        ],
        id: '31',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'Here comes the silent alarm.',
            },
        ],
        id: '32',
    },
    {
        type: 'character',
        children: [
            {
                text: 'HAPPY',
            },
        ],
        id: '33',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'Is it a problem?',
            },
        ],
        id: '34',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. STAIRWELL, BANK -- DAY',
            },
        ],
        id: '35',
    },
    {
        type: 'action',
        children: [
            {
                text: '...and speeds down the stairs, to the basement. He SLAMS open the door...',
            },
        ],
        id: '36',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. VAULT ROOM, BANK -- DAY',
            },
        ],
        id: '37',
    },
    {
        type: 'action',
        children: [
            {
                text: '...and comes face to face with a huge VAULT.',
            },
        ],
        id: '38',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. LOBBY, BANK -- DAY',
            },
        ],
        id: '39',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Bozo and Grumpy move down the line of hostages- Bozo hands each Hostage OBJECTS from a bag. A GRENADE. Grumpy follows, PULLING THE PINS.',
            },
        ],
        id: '40',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GRUMPY',
            },
        ],
        id: '41',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "Obviously, we don't want you doing anything with your hands other than holding on for dear life.",
            },
        ],
        id: '42',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. VAULT ROOM, BANK -- DAY',
            },
        ],
        id: '43',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Happy CLAMPS a DRILL to the vault- the bit SPINS- SLIDES into the metal door- a BOLT of ELECTRICITY RIPS THROUGH THE DRILL, THROWING HAPPY TO THE FLOOR-',
            },
        ],
        id: '44',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. LOBBY, BANK -- DAY',
            },
        ],
        id: '45',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GRUMPY',
            },
        ],
        id: '46',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "He's got three left?",
            },
        ],
        id: '47',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. VAULT ROOM, BANK -- DAY',
            },
        ],
        id: '48',
    },
    {
        type: 'character',
        children: [
            {
                text: 'HAPPY',
            },
        ],
        id: '49',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'They wired this thing up with 5,000 volts. What kind of bank does that?',
            },
        ],
        id: '50',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GRUMPY',
            },
        ],
        id: '51',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "A mob bank. Guess the Joker's as crazy as they say.",
            },
        ],
        id: '52',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. VAULT, BANK -- DAY',
            },
        ],
        id: '53',
    },
    {
        type: 'action',
        children: [
            {
                text: '...which is filled with an eight-foot MOUNTAIN OF CASH.',
            },
        ],
        id: '54',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. LOBBY, BANK -- DAY',
            },
        ],
        id: '55',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Grumpy walks into the lobby, straining under several DUFFELS filled with cash. He DUMPS them.',
            },
        ],
        id: '56',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GRUMPY',
            },
        ],
        id: '57',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "C'mon, there's a lot to carry...",
            },
        ],
        id: '58',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. LOBBY, BANK -- DAY',
            },
        ],
        id: '59',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Bozo walks back into the lobby with two more DUFFELS. Sets them down on an ENORMOUS PILE.',
            },
        ],
        id: '60',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GRUMPY',
            },
        ],
        id: '61',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'If this guy was so smart he would have had us bring a bigger car.',
            },
        ],
        id: '62',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. BANK -- CONTINUOUS',
            },
        ],
        id: '63',
    },
    {
        type: 'character',
        children: [
            {
                text: 'BOZO',
            },
        ],
        id: '64',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'No. I kill the bus driver.',
            },
        ],
        id: '65',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. BANK -- CONTINUOUS',
            },
        ],
        id: '66',
    },
    {
        type: 'action',
        children: [
            {
                text: 'The School Bus pulls free of the Bank wall and pulls out onto the street, SLIDING INTO THE LINE OF IDENTICAL BUSES HEADING PAST THE BANK.',
            },
        ],
        id: '67',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. MOVING OVER GOTHAM -- NIGHT',
            },
        ],
        id: '68',
    },
    {
        type: 'action',
        children: [
            {
                text: 'From the top of a brick building a SHAFT OF LIGHT comes on.',
            },
        ],
        id: '69',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. VARIOUS LOCATIONS -- CONTINUOUS',
            },
        ],
        id: '70',
    },
    {
        type: 'character',
        children: [
            {
                text: 'DEALER',
            },
        ],
        id: '71',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "No, man. I don't like it tonight.",
            },
        ],
        id: '72',
    },
    {
        type: 'character',
        children: [
            {
                text: 'BUYER',
            },
        ],
        id: '73',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "What're you, superstitious? You got more chance of winning the powerball than running into him...",
            },
        ],
        id: '74',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. MAJOR CRIMES UNIT, GOTHAM CENTRAL -- NIGHT',
            },
        ],
        id: '75',
    },
    {
        type: 'character',
        children: [
            {
                text: 'RAMIREZ',
            },
        ],
        id: '76',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "Hey, Wuertz— the Mayor says you're closing in on the Batman.",
            },
        ],
        id: '77',
    },
    {
        type: 'character',
        children: [
            {
                text: 'WUERTZ',
            },
        ],
        id: '78',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'The investigation is ongoing.',
            },
        ],
        id: '79',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. ROOFTOP, MAJOR CRIMES UNIT -- NIGHT',
            },
        ],
        id: '80',
    },
    {
        type: 'character',
        children: [
            {
                text: 'RAMIREZ',
            },
        ],
        id: '81',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "He hasn't shown?",
            },
        ],
        id: '82',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GORDON',
            },
        ],
        id: '83',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "Often doesn't. But I like reminding everybody that he's out there.",
            },
        ],
        id: '84',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. PARKING GARAGE -- NIGHT',
            },
        ],
        id: '85',
    },
    {
        type: 'action',
        children: [
            {
                text: "Two black SUV's pull onto the top floor. A large man emerges— the CHECHEN. A BODYGUARD points at the sky.",
            },
        ],
        id: '86',
    },
    {
        type: 'character',
        children: [
            {
                text: 'CHECHEN',
            },
        ],
        id: '87',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "That's why we bring dogs.",
            },
        ],
        id: '88',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. PARKING GARAGE -- CONTINUOUS',
            },
        ],
        id: '89',
    },
    {
        type: 'character',
        children: [
            {
                text: 'CHECHEN',
            },
        ],
        id: '90',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "My little princes... The Batman's invisible to you fools... but my little princes... they can find human meat in complete darkness.",
            },
        ],
        id: '91',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. VAN -- CONTINUOUS',
            },
        ],
        id: '92',
    },
    {
        type: 'character',
        children: [
            {
                text: 'SCARECROW',
            },
        ],
        id: '93',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "Buyer beware... I told your man my compound would take you places. I never said they'd be places you wanted to go.",
            },
        ],
        id: '94',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. PARKING GARAGE -- CONTINUOUS',
            },
        ],
        id: '95',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Suddenly, a shadow straightens—POINTED BAT-EARS against the skyline. More shadows appear. A trap.',
            },
        ],
        id: '96',
    },
    {
        type: 'character',
        children: [
            {
                text: 'CHECHEN',
            },
        ],
        id: '97',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "Come on, sonofabitch—my dogs are hungry, pity there's only one of you...",
            },
        ],
        id: '98',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. VAN -- CONTINUOUS',
            },
        ],
        id: '99',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Scarecrow ducks into the van. A shotgun muzzle presses to the back of his head. He sprays fear toxin—wrong Batman. Fake.',
            },
        ],
        id: '100',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. PARKING GARAGE -- CONTINUOUS',
            },
        ],
        id: '101',
    },
    {
        type: 'action',
        children: [
            {
                text: 'The REAL Batman drops onto a row of parked cars. The Batmobile ROARS onto the scene. The imposters are caught.',
            },
        ],
        id: '102',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. VAN -- CONTINUOUS',
            },
        ],
        id: '103',
    },
    {
        type: 'character',
        children: [
            {
                text: 'SCARECROW',
            },
        ],
        id: '104',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'Not the real thing.',
            },
        ],
        id: '105',
    },
    {
        type: 'character',
        children: [
            {
                text: 'CHECHEN',
            },
        ],
        id: '106',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'How you know?',
            },
        ],
        id: '107',
    },
    {
        type: 'character',
        children: [
            {
                text: 'SCARECROW',
            },
        ],
        id: '108',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "We're old friends.",
            },
        ],
        id: '109',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. ROOFTOP, PARKING GARAGE -- MOMENTS LATER',
            },
        ],
        id: '110',
    },
    {
        type: 'action',
        children: [
            {
                text: "The Chechen's men and the fake Batmen are zip-tied. Batman dumps Scarecrow next to them.",
            },
        ],
        id: '111',
    },
    {
        type: 'character',
        children: [
            {
                text: '"BATMAN"',
            },
        ],
        id: '112',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "We're trying to help you!",
            },
        ],
        id: '113',
    },
    {
        type: 'character',
        children: [
            {
                text: 'BATMAN',
            },
        ],
        id: '114',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "I don't need help.",
            },
        ],
        id: '115',
    },
    {
        type: 'character',
        children: [
            {
                text: 'SCARECROW',
            },
        ],
        id: '116',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'Not my diagnosis.',
            },
        ],
        id: '117',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. BATMOBILE -- CONTINUOUS',
            },
        ],
        id: '118',
    },
    {
        type: 'action',
        children: [
            {
                text: "Batman enters, cockpit hisses shut. 'LOITER' changes to 'INTIMIDATE' on the HUD. He leaves.",
            },
        ],
        id: '119',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'EXT. BANK -- NIGHT',
            },
        ],
        id: '120',
    },
    {
        type: 'action',
        children: [
            {
                text: 'Gordon enters the ransacked Gotham National Bank, dodging reporters. SWAT already inside.',
            },
        ],
        id: '121',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. LOBBY, BANK -- NIGHT',
            },
        ],
        id: '122',
    },
    {
        type: 'character',
        children: [
            {
                text: 'RAMIREZ',
            },
        ],
        id: '123',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: "He can't resist showing us his face.",
            },
        ],
        id: '124',
    },
    {
        type: 'scene',
        children: [
            {
                text: 'INT. LOBBY, BANK -- CONTINUOUS',
            },
        ],
        id: '125',
    },
    {
        type: 'action',
        children: [
            {
                text: "Grainy surveillance image of Joker's face in clown makeup. Gordon and Batman examine evidence.",
            },
        ],
        id: '126',
    },
    {
        type: 'character',
        children: [
            {
                text: 'BATMAN',
            },
        ],
        id: '127',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'Some of the marked bills I gave you.',
            },
        ],
        id: '128',
    },
    {
        type: 'character',
        children: [
            {
                text: 'GORDON',
            },
        ],
        id: '129',
    },
    {
        type: 'dialogue',
        children: [
            {
                text: 'My detectives have been making drug buys with them for weeks. This bank was another drop.',
            },
        ],
        id: '130',
    },
]
